export default __webpack_public_path__ + "static/media/powerOffButton.565e8b96.png";